
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Sinister } from '../../../../typescript/sinisters/sinisterInfo';
import { Note, SamplingClassification } from '../../../../typescript/notes/notes';
import InspectionAppraisers from './appraisers/InspectionAppraisers.vue';
import InspectionNotes from './notes/InspectionNotes.vue';
import InspectionSamplingReport from '../../../../samplings/components/InspectionSamplingReport.vue';
import { defaultUserPrivilege, PrivilegeValue, PRIVILEGE_KEYS } from '../../../../../privileges/privileges';
import { ItemWithSinistersApi } from '../../../../core/api/ItemWithSinistersApi';
import { buildClassificationColorMap } from '../../../../samplings/colors';
import {
  buildClassificationNameMap,
  enrichNotesWithClassificationNames,
  getUnclassifiedSamplingsFromNotes,
  UnclassifiedSampling,
} from '../../../../samplings/enrich-notes';

@Component({
  components: {
    InspectionAppraisers,
    InspectionNotes,
    InspectionSamplingReport,
  },
})
export default class InspectionSection extends Vue {
  @Prop({ required: true }) sinister!: Sinister;
  @Prop({ default: () => defaultUserPrivilege }) privilege!: PrivilegeValue;
  @Prop({ default: null }) selectedNoteId!: number | null;

  activeTab: number = 0;
  readonly notesTabIndex: number = 1;

  // Seleccion desde el mapa: llevar al usuario a la pestaña de notas
  @Watch('selectedNoteId')
  onSelectedNoteIdChange(noteId: number | null) {
    if (noteId != null) this.activeTab = this.notesTabIndex;
  }
  samplingClassifications: SamplingClassification[] = [];
  classificationNames: Record<number, string> = {};
  classificationColors: Record<number, string> = {};
  unclassifiedSamplings: UnclassifiedSampling[] = [];
  loadingClassifications: boolean = false;

  get showSamplingReportTab(): boolean {
    return this.privilege === PRIVILEGE_KEYS.CLAIM;
  }

  mounted() {
    this.loadNotesForMap();
  }

  /** Load notes (and classifications if CLAIM) so markers appear on the map */
  loadNotesForMap() {
    const notesPromise = ItemWithSinistersApi.getSinisterNotes(this.sinister.id);
    const classificationsPromise = this.showSamplingReportTab
      ? (() => {
          this.loadingClassifications = true;
          return ItemWithSinistersApi.getSamplingClassifications(this.sinister.id)
            .then(res => {
              const list = res.sampling_classifications || [];
              this.samplingClassifications = list;
              this.classificationNames = buildClassificationNameMap(list);
              this.classificationColors = buildClassificationColorMap(list);
            })
            .catch(() => {
              this.samplingClassifications = [];
              this.classificationNames = {};
              this.classificationColors = {};
            })
            .finally(() => {
              this.loadingClassifications = false;
            });
        })()
      : Promise.resolve();

    Promise.all([notesPromise, classificationsPromise])
      .then(([notesRes]) => {
        const notes = notesRes.ranch_notes || [];
        const enriched = this.showSamplingReportTab
          ? enrichNotesWithClassificationNames(
              notes,
              this.classificationNames,
              this.classificationColors
            )
          : notes;
        this.onSeeNotesInMap(enriched);
      })
      .catch(() => {
        // Map notes are best-effort on load; NoteForm will surface errors when the tab opens
      });
  }

  @Emit('see-notes-in-map')
  onSeeNotesInMap(notes: Note[]) {
    if (this.showSamplingReportTab) {
      this.unclassifiedSamplings = getUnclassifiedSamplingsFromNotes(notes);
    } else {
      this.unclassifiedSamplings = [];
    }
    return notes;
  }
}
